import { createFileRoute, notFound } from "@tanstack/react-router";
import { workRequestIdSchema } from "../lib/workIds";

export const Route = createFileRoute("/_app/requests/$workRequestId")({
  params: {
    parse: (params) => {
      const parsed = workRequestIdSchema.safeParse(params.workRequestId);
      if (!parsed.success) throw notFound();
      return { workRequestId: parsed.data };
    },
  },
  component: () => null,
});
